import { createAction, props } from '@ngrx/store'
import { Department } from './department.state'

// Action to load Department
export const loadDepartments = createAction(
  '[Department] Load Departments',
  props<{ params: string | null; page?: number; limit?: number }>()
)

// Action for successful Department load
export const loadDepartmentsSuccess = createAction(
  '[Department] Load Department Success',
  props<{
    totalCount: number
    departments: Department[]
  }>()
)

// Action for Department load failure
export const loadDepartmentsFailure = createAction(
  '[Department] Load Department Failure',
  props<{ error: string }>()
)

export const loadDepartmentCounts = createAction('[Department] Load Counts')
export const setDepartmentCounts = createAction(
  '[Department] Set Counts',
  props<{ totalCount: number }>()
)

export const createDepartment = createAction(
  '[Department] Create Department',
  props<{
    departmentName: string
    businessId: string
  }>()
)

export const createDepartmentSuccess = createAction(
  '[Department] Create Department Success',
  props<{ department: Department }>()
)

export const createDepartmentFailure = createAction(
  '[Department] Create Department Failure',
  props<{ error: any }>()
)

export const updateDepartment = createAction(
  '[Department] Update Department',
  props<{
    id: string
    departmentName: string
    businessId: string
  }>()
)

export const updateDepartmentSuccess = createAction(
  '[Department] Update Department Success',
  props<{ department: Department }>()
)

export const updateDepartmentFailure = createAction(
  '[Department] Update Department Failure',
  props<{ error: any }>()
)

export const blockDepartment = createAction(
  '[Department] Block Department',
  props<{ id: string; disabled: boolean }>()
)

export const blockDepartmentSuccess = createAction(
  '[Department] Block Department Success',
  props<{ department: Department }>()
)

export const blockDepartmentFailure = createAction(
  '[Department] Block Department Failure',
  props<{ error: string }>()
)

export const unblockDepartment = createAction(
  '[Department] Unblock Department',
  props<{ id: string; disabled: boolean }>()
)

export const unblockDepartmentSuccess = createAction(
  '[Department] Unblock Department Success',
  props<{ id: string }>()
)

export const unblockDepartmentFailure = createAction(
  '[Department] Unblock Department Failure',
  props<{ error: string }>()
)

export const deleteDepartment = createAction(
  '[Department] Delete Department',
  props<{ id: string }>()
)

export const deleteDepartmentSuccess = createAction(
  '[Department] Delete Department Success',
  props<{ id: string }>()
)

export const deleteDepartmentFailure = createAction(
  '[Department] Delete Department Failure',
  props<{ error: any }>()
)

export const resetDepartmentState = createAction('[Department] Reset State')
